"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductionOrderStatus = void 0;
const ProductionOrderStatus = exports.ProductionOrderStatus = {
  PAUSED: 0,
  CREATED: 1,
  PRODUCTION: 2,
  FINISHED_NOK: 3,
  FINISHED_OK: 4,
  SHIPPED: 5,
  CANCELLED: 6
};